<template>
  <div
    class="block-link-box"
    :class="[`is-${alignment}`]"
  >
    <UtilWrapperLayout>
      <UtilGrid>
        <div class="block-link-box__inner is-multiple">
          <AtomRichtext
            v-if="text"
            class="block-link-box__richtext"
            :html="text"
          />

          <AtomLink
            class="block-link-box__arrow-text"
            :text="label"
            :link="link"
            :target="target"
            icon="chevron-right"
          />
        </div>
      </UtilGrid>
    </UtilWrapperLayout>
  </div>
</template>

<script setup>
const props = defineProps({
    link: {
        type: String,
        default: '',
    },

    label: {
        type: String,
        default: '',
    },

    text: {
        type: String,
        default: '',
    },

    alignment: {
        type: String,
        default: 'center',
    },

    target: {
        type: String,
        default: '_self',
    },

    filterQuery: {
        type: Array,
        default: () => [],
    },
});

provide('filterQuery', isArrayNotEmpty(props.filterQuery) ? props.filterQuery[0] : null);
</script>

<style lang="scss" scoped>
.block-link-box {
    @include fluid('margin-bottom', 66px, 177px);
    @include grid-columns(3, 6);

    &:last-child {
        margin-bottom: 0;
    }

    display: flex;
    flex-direction: column;
    font-size: var(--f-size--richtext);
    line-height: var(--f-line-height--richtext);
    row-gap: 10px;

    &.is-left {
        grid-column-start: 1;
    }

    &.is-right {
        grid-column-start: 6;
    }

    &.is-left, &.is-right {
        @include mobile {
            grid-column-start: 1;
        }
    }
}

.block-link-box__inner {
    @include default-content-columns;
}
</style>
